import React from 'react';

export const BoardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="5"
      y="4"
      width="14"
      height="17"
      rx="2"
      stroke="#27B0E0"
      strokeWidth="2"
    />
    <path d="M15 13H9" stroke="#27B0E0" strokeWidth="2" strokeLinecap="round" />
    <path d="M13 17H9" stroke="#27B0E0" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M12 9L9 9"
      stroke="#27B0E0"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="9"
      y="2"
      width="6"
      height="3"
      rx="1.5"
      fill="white"
      stroke="#27B0E0"
      strokeWidth="2"
    />
  </svg>
);
